import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-file-types',
  templateUrl: './admin-file-types.component.html',
  styleUrls: ['./admin-file-types.component.scss']
})
export class AdminFileTypesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
